export type Country = {
  countryCode: string;
  countryNameEn: string;
  countryCallingCode: string;
  center: [number, number] | undefined;
};

export const countries: Country[] = [
  {
    countryCode: 'AD',
    countryNameEn: 'Andorra',
    countryCallingCode: '376',
    center: [42.5, 1.6],
  },
  {
    countryCode: 'AF',
    countryNameEn: 'Afghanistan',
    countryCallingCode: '93',
    center: [33, 65],
  },
  {
    countryCode: 'AG',
    countryNameEn: 'Antigua and Barbuda',
    countryCallingCode: '1268',
    center: [17.05, -61.8],
  },
  {
    countryCode: 'AI',
    countryNameEn: 'Anguilla',
    countryCallingCode: '1264',
    center: [18.25, -63.1667],
  },
  {
    countryCode: 'AL',
    countryNameEn: 'Albania',
    countryCallingCode: '355',
    center: [41, 20],
  },
  {
    countryCode: 'AM',
    countryNameEn: 'Armenia',
    countryCallingCode: '374',
    center: [40, 45],
  },
  {
    countryCode: 'AO',
    countryNameEn: 'Angola',
    countryCallingCode: '244',
    center: [-12.5, 18.5],
  },
  {
    countryCode: 'AQ',
    countryNameEn: 'Antarctica',
    countryCallingCode: '',
    center: [-90, 0],
  },
  {
    countryCode: 'AR',
    countryNameEn: 'Argentina',
    countryCallingCode: '54',
    center: [-34, -64],
  },
  {
    countryCode: 'AS',
    countryNameEn: 'American Samoa',
    countryCallingCode: '1684',
    center: [-14.3333, -170],
  },
  {
    countryCode: 'AT',
    countryNameEn: 'Austria',
    countryCallingCode: '43',
    center: [47.3333, 13.3333],
  },
  {
    countryCode: 'AU',
    countryNameEn: 'Australia',
    countryCallingCode: '61',
    center: [-27, 133],
  },
  {
    countryCode: 'AW',
    countryNameEn: 'Aruba',
    countryCallingCode: '297',
    center: [12.5, -69.9667],
  },
  {
    countryCode: 'AX',
    countryNameEn: 'Åland Islands',
    countryCallingCode: '358',
    center: [60.25, 19.91],
  },
  {
    countryCode: 'AZ',
    countryNameEn: 'Azerbaijan',
    countryCallingCode: '994',
    center: [40.5, 47.5],
  },
  {
    countryCode: 'BA',
    countryNameEn: 'Bosnia and Herzegovina',
    countryCallingCode: '387',
    center: [44, 18],
  },
  {
    countryCode: 'BB',
    countryNameEn: 'Barbados',
    countryCallingCode: '1246',
    center: [13.1667, -59.5333],
  },
  {
    countryCode: 'BD',
    countryNameEn: 'Bangladesh',
    countryCallingCode: '880',
    center: [24, 90],
  },
  {
    countryCode: 'BE',
    countryNameEn: 'Belgium',
    countryCallingCode: '32',
    center: [50.8333, 4],
  },
  {
    countryCode: 'BF',
    countryNameEn: 'Burkina Faso',
    countryCallingCode: '226',
    center: [13, -2],
  },
  {
    countryCode: 'BG',
    countryNameEn: 'Bulgaria',
    countryCallingCode: '359',
    center: [43, 25],
  },
  {
    countryCode: 'BH',
    countryNameEn: 'Bahrain',
    countryCallingCode: '973',
    center: [26, 50.55],
  },
  {
    countryCode: 'BI',
    countryNameEn: 'Burundi',
    countryCallingCode: '257',
    center: [-3.5, 30],
  },
  {
    countryCode: 'BJ',
    countryNameEn: 'Benin',
    countryCallingCode: '229',
    center: [9.5, 2.25],
  },
  {
    countryCode: 'BL',
    countryNameEn: 'Saint Barthélemy',
    countryCallingCode: '590',
    center: [17.89, -62.83],
  },
  {
    countryCode: 'BM',
    countryNameEn: 'Bermuda',
    countryCallingCode: '1441',
    center: [32.3333, -64.75],
  },
  {
    countryCode: 'BN',
    countryNameEn: 'Brunei Darussalam',
    countryCallingCode: '673',
    center: [4.5, 114.6667],
  },
  {
    countryCode: 'BO',
    countryNameEn: 'Bolivia (Plurinational State of)',
    countryCallingCode: '591',
    center: [-17, -65],
  },
  {
    countryCode: 'BQ',
    countryNameEn: 'Bonaire, Sint Eustatius and Saba',
    countryCallingCode: '5997',
    center: [12.16, -68.3],
  },
  {
    countryCode: 'BR',
    countryNameEn: 'Brazil',
    countryCallingCode: '55',
    center: [-10, -55],
  },
  {
    countryCode: 'BT',
    countryNameEn: 'Bhutan',
    countryCallingCode: '975',
    center: [27.5, 90.5],
  },
  {
    countryCode: 'BV',
    countryNameEn: 'Bouvet Island',
    countryCallingCode: '',
    center: [-54.4333, 3.4],
  },
  {
    countryCode: 'BW',
    countryNameEn: 'Botswana',
    countryCallingCode: '267',
    center: [-22, 24],
  },
  {
    countryCode: 'BY',
    countryNameEn: 'Belarus',
    countryCallingCode: '375',
    center: [53, 28],
  },
  {
    countryCode: 'BZ',
    countryNameEn: 'Belize',
    countryCallingCode: '501',
    center: [17.25, -88.75],
  },
  {
    countryCode: 'CA',
    countryNameEn: 'Canada',
    countryCallingCode: '1',
    center: [60, -95],
  },
  {
    countryCode: 'CH',
    countryNameEn: 'Switzerland',
    countryCallingCode: '41',
    center: [47, 8],
  },
  {
    countryCode: 'CI',
    countryNameEn: "Côte d'Ivoire",
    countryCallingCode: '',
    center: [8, -5],
  },
  {
    countryCode: 'CL',
    countryNameEn: 'Chile',
    countryCallingCode: '56',
    center: [-30, -71],
  },
  {
    countryCode: 'CM',
    countryNameEn: 'Cameroon',
    countryCallingCode: '237',
    center: [6, 12],
  },
  {
    countryCode: 'CN',
    countryNameEn: 'China',
    countryCallingCode: '86',
    center: [35, 105],
  },
  {
    countryCode: 'CO',
    countryNameEn: 'Colombia',
    countryCallingCode: '57',
    center: [4, -72],
  },
  {
    countryCode: 'CR',
    countryNameEn: 'Costa Rica',
    countryCallingCode: '506',
    center: [10, -84],
  },
  {
    countryCode: 'CU',
    countryNameEn: 'Cuba',
    countryCallingCode: '53',
    center: [21.5, -80],
  },
  {
    countryCode: 'CV',
    countryNameEn: 'Cabo Verde',
    countryCallingCode: '',
    center: [16, -24],
  },
  {
    countryCode: 'CW',
    countryNameEn: 'Curaçao',
    countryCallingCode: '599',
    center: [12.19, -68.97],
  },
  {
    countryCode: 'CX',
    countryNameEn: 'Christmas Island',
    countryCallingCode: '61',
    center: [-10.5, 105.6667],
  },
  {
    countryCode: 'CY',
    countryNameEn: 'Cyprus',
    countryCallingCode: '357',
    center: [35, 33],
  },
  {
    countryCode: 'DE',
    countryNameEn: 'Germany',
    countryCallingCode: '49',
    center: [51, 9],
  },
  {
    countryCode: 'DJ',
    countryNameEn: 'Djibouti',
    countryCallingCode: '253',
    center: [11.5, 43],
  },
  {
    countryCode: 'DK',
    countryNameEn: 'Denmark',
    countryCallingCode: '45',
    center: [56, 10],
  },
  {
    countryCode: 'DM',
    countryNameEn: 'Dominica',
    countryCallingCode: '767',
    center: [15.4167, -61.3333],
  },
  {
    countryCode: 'DZ',
    countryNameEn: 'Algeria',
    countryCallingCode: '213',
    center: [28, 3],
  },
  {
    countryCode: 'EC',
    countryNameEn: 'Ecuador',
    countryCallingCode: '593',
    center: [-2, -77.5],
  },
  {
    countryCode: 'EE',
    countryNameEn: 'Estonia',
    countryCallingCode: '372',
    center: [59, 26],
  },
  {
    countryCode: 'EG',
    countryNameEn: 'Egypt',
    countryCallingCode: '20',
    center: [27, 30],
  },
  {
    countryCode: 'EH',
    countryNameEn: 'Western Sahara',
    countryCallingCode: '',
    center: [24.5, -13],
  },
  {
    countryCode: 'ER',
    countryNameEn: 'Eritrea',
    countryCallingCode: '291',
    center: [15, 39],
  },
  {
    countryCode: 'ES',
    countryNameEn: 'Spain',
    countryCallingCode: '34',
    center: [40, -4],
  },
  {
    countryCode: 'ET',
    countryNameEn: 'Ethiopia',
    countryCallingCode: '251',
    center: [8, 38],
  },
  {
    countryCode: 'FI',
    countryNameEn: 'Finland',
    countryCallingCode: '358',
    center: [64, 26],
  },
  {
    countryCode: 'FJ',
    countryNameEn: 'Fiji',
    countryCallingCode: '679',
    center: [-18, 175],
  },
  {
    countryCode: 'FM',
    countryNameEn: 'Micronesia (Federated States of)',
    countryCallingCode: '691',
    center: [6.9167, 158.25],
  },
  {
    countryCode: 'FR',
    countryNameEn: 'France',
    countryCallingCode: '33',
    center: [46, 2],
  },
  {
    countryCode: 'GA',
    countryNameEn: 'Gabon',
    countryCallingCode: '241',
    center: [-1, 11.75],
  },
  {
    countryCode: 'GD',
    countryNameEn: 'Grenada',
    countryCallingCode: '1473',
    center: [12.1167, -61.6667],
  },
  {
    countryCode: 'GE',
    countryNameEn: 'Georgia',
    countryCallingCode: '995',
    center: [42, 43.5],
  },
  {
    countryCode: 'GF',
    countryNameEn: 'French Guiana',
    countryCallingCode: '594',
    center: [4, -53],
  },
  {
    countryCode: 'GG',
    countryNameEn: 'Guernsey',
    countryCallingCode: '44',
    center: [49.5, -2.56],
  },
  {
    countryCode: 'GH',
    countryNameEn: 'Ghana',
    countryCallingCode: '233',
    center: [8, -2],
  },
  {
    countryCode: 'GI',
    countryNameEn: 'Gibraltar',
    countryCallingCode: '350',
    center: [36.1833, -5.3667],
  },
  {
    countryCode: 'GL',
    countryNameEn: 'Greenland',
    countryCallingCode: '299',
    center: [72, -40],
  },
  {
    countryCode: 'GN',
    countryNameEn: 'Guinea',
    countryCallingCode: '224',
    center: [11, -10],
  },
  {
    countryCode: 'GP',
    countryNameEn: 'Guadeloupe',
    countryCallingCode: '590',
    center: [16.25, -61.5833],
  },
  {
    countryCode: 'GQ',
    countryNameEn: 'Equatorial Guinea',
    countryCallingCode: '240',
    center: [2, 10],
  },
  {
    countryCode: 'GR',
    countryNameEn: 'Greece',
    countryCallingCode: '30',
    center: [39, 22],
  },
  {
    countryCode: 'GS',
    countryNameEn: 'South Georgia and the South Sandwich Islands',
    countryCallingCode: '500',
    center: [-54.5, -37],
  },
  {
    countryCode: 'GT',
    countryNameEn: 'Guatemala',
    countryCallingCode: '502',
    center: [15.5, -90.25],
  },
  {
    countryCode: 'GU',
    countryNameEn: 'Guam',
    countryCallingCode: '1',
    center: [13.4667, 144.7833],
  },
  {
    countryCode: 'GW',
    countryNameEn: 'Guinea-Bissau',
    countryCallingCode: '245',
    center: [12, -15],
  },
  {
    countryCode: 'GY',
    countryNameEn: 'Guyana',
    countryCallingCode: '592',
    center: [5, -59],
  },
  {
    countryCode: 'HK',
    countryNameEn: 'Hong Kong',
    countryCallingCode: '852',
    center: [22.25, 114.1667],
  },
  {
    countryCode: 'HN',
    countryNameEn: 'Honduras',
    countryCallingCode: '504',
    center: [15, -86.5],
  },
  {
    countryCode: 'HR',
    countryNameEn: 'Croatia',
    countryCallingCode: '385',
    center: [45.1667, 15.5],
  },
  {
    countryCode: 'HT',
    countryNameEn: 'Haiti',
    countryCallingCode: '509',
    center: [19, -72.4167],
  },
  {
    countryCode: 'HU',
    countryNameEn: 'Hungary',
    countryCallingCode: '36',
    center: [47, 20],
  },
  {
    countryCode: 'ID',
    countryNameEn: 'Indonesia',
    countryCallingCode: '62',
    center: [-5, 120],
  },
  {
    countryCode: 'IE',
    countryNameEn: 'Ireland',
    countryCallingCode: '353',
    center: [53, -8],
  },
  {
    countryCode: 'IL',
    countryNameEn: 'Israel',
    countryCallingCode: '972',
    center: [31.5, 34.75],
  },
  {
    countryCode: 'IM',
    countryNameEn: 'Isle of Man',
    countryCallingCode: '44',
    center: [54.23, -4.55],
  },
  {
    countryCode: 'IN',
    countryNameEn: 'India',
    countryCallingCode: '91',
    center: [20, 77],
  },
  {
    countryCode: 'IQ',
    countryNameEn: 'Iraq',
    countryCallingCode: '964',
    center: [33, 44],
  },
  {
    countryCode: 'IR',
    countryNameEn: 'Iran (Islamic Republic of)',
    countryCallingCode: '98',
    center: [32, 53],
  },
  {
    countryCode: 'IS',
    countryNameEn: 'Iceland',
    countryCallingCode: '354',
    center: [65, -18],
  },
  {
    countryCode: 'IT',
    countryNameEn: 'Italy',
    countryCallingCode: '39',
    center: [42.8333, 12.8333],
  },
  {
    countryCode: 'JE',
    countryNameEn: 'Jersey',
    countryCallingCode: '44',
    center: [49.21, -2.13],
  },
  {
    countryCode: 'JM',
    countryNameEn: 'Jamaica',
    countryCallingCode: '876',
    center: [18.25, -77.5],
  },
  {
    countryCode: 'JO',
    countryNameEn: 'Jordan',
    countryCallingCode: '962',
    center: [31, 36],
  },
  {
    countryCode: 'JP',
    countryNameEn: 'Japan',
    countryCallingCode: '81',
    center: [36, 138],
  },
  {
    countryCode: 'KE',
    countryNameEn: 'Kenya',
    countryCallingCode: '254',
    center: [1, 38],
  },
  {
    countryCode: 'KG',
    countryNameEn: 'Kyrgyzstan',
    countryCallingCode: '996',
    center: [41, 75],
  },
  {
    countryCode: 'KH',
    countryNameEn: 'Cambodia',
    countryCallingCode: '855',
    center: [13, 105],
  },
  {
    countryCode: 'KP',
    countryNameEn: 'North Korea',
    countryCallingCode: '850',
    center: [40, 127],
  },
  {
    countryCode: 'KR',
    countryNameEn: 'South Korea',
    countryCallingCode: '82',
    center: [37, 127.5],
  },
  {
    countryCode: 'KI',
    countryNameEn: 'Kiribati',
    countryCallingCode: '686',
    center: [1.4167, 173],
  },
  {
    countryCode: 'KN',
    countryNameEn: 'Saint Kitts and Nevis',
    countryCallingCode: '1869',
    center: [17.3333, -62.75],
  },
  {
    countryCode: 'KW',
    countryNameEn: 'Kuwait',
    countryCallingCode: '965',
    center: [29.3375, 47.6581],
  },
  {
    countryCode: 'KZ',
    countryNameEn: 'Kazakhstan',
    countryCallingCode: '7',
    center: [48, 68],
  },
  {
    countryCode: 'LB',
    countryNameEn: 'Lebanon',
    countryCallingCode: '961',
    center: [33.8333, 35.8333],
  },
  {
    countryCode: 'LC',
    countryNameEn: 'Saint Lucia',
    countryCallingCode: '1758',
    center: [13.8833, -61.1333],
  },
  {
    countryCode: 'LI',
    countryNameEn: 'Liechtenstein',
    countryCallingCode: '423',
    center: [47.1667, 9.5333],
  },
  {
    countryCode: 'LK',
    countryNameEn: 'Sri Lanka',
    countryCallingCode: '94',
    center: [7, 81],
  },
  {
    countryCode: 'LR',
    countryNameEn: 'Liberia',
    countryCallingCode: '231',
    center: [6.5, -9.5],
  },
  {
    countryCode: 'LS',
    countryNameEn: 'Lesotho',
    countryCallingCode: '266',
    center: [-29.5, 28.5],
  },
  {
    countryCode: 'LT',
    countryNameEn: 'Lithuania',
    countryCallingCode: '370',
    center: [56, 24],
  },
  {
    countryCode: 'LU',
    countryNameEn: 'Luxembourg',
    countryCallingCode: '352',
    center: [49.75, 6.1667],
  },
  {
    countryCode: 'LV',
    countryNameEn: 'Latvia',
    countryCallingCode: '371',
    center: [57, 25],
  },
  {
    countryCode: 'LY',
    countryNameEn: 'Libya',
    countryCallingCode: '218',
    center: [25, 17],
  },
  {
    countryCode: 'MA',
    countryNameEn: 'Morocco',
    countryCallingCode: '212',
    center: [32, -5],
  },
  {
    countryCode: 'MC',
    countryNameEn: 'Monaco',
    countryCallingCode: '377',
    center: [43.7333, 7.4],
  },
  {
    countryCode: 'ME',
    countryNameEn: 'Montenegro',
    countryCallingCode: '382',
    center: [42, 19],
  },
  {
    countryCode: 'MF',
    countryNameEn: 'Saint Martin (French part)',
    countryCallingCode: '590',
    center: [18.06, -63.06],
  },
  {
    countryCode: 'MG',
    countryNameEn: 'Madagascar',
    countryCallingCode: '261',
    center: [-20, 47],
  },
  {
    countryCode: 'ML',
    countryNameEn: 'Mali',
    countryCallingCode: '223',
    center: [17, -4],
  },
  {
    countryCode: 'MM',
    countryNameEn: 'Myanmar',
    countryCallingCode: '95',
    center: [22, 98],
  },
  {
    countryCode: 'MN',
    countryNameEn: 'Mongolia',
    countryCallingCode: '976',
    center: [46, 105],
  },
  {
    countryCode: 'MO',
    countryNameEn: 'Macao',
    countryCallingCode: '',
    center: [22.1667, 113.55],
  },
  {
    countryCode: 'MQ',
    countryNameEn: 'Martinique',
    countryCallingCode: '596',
    center: [14.6667, -61],
  },
  {
    countryCode: 'MR',
    countryNameEn: 'Mauritania',
    countryCallingCode: '222',
    center: [20, -12],
  },
  {
    countryCode: 'MS',
    countryNameEn: 'Montserrat',
    countryCallingCode: '1664',
    center: [16.75, -62.2],
  },
  {
    countryCode: 'MT',
    countryNameEn: 'Malta',
    countryCallingCode: '356',
    center: [35.8333, 14.5833],
  },
  {
    countryCode: 'MU',
    countryNameEn: 'Mauritius',
    countryCallingCode: '230',
    center: [-20.2833, 57.55],
  },
  {
    countryCode: 'MV',
    countryNameEn: 'Maldives',
    countryCallingCode: '960',
    center: [3.25, 73],
  },
  {
    countryCode: 'MW',
    countryNameEn: 'Malawi',
    countryCallingCode: '265',
    center: [-13.5, 34],
  },
  {
    countryCode: 'MX',
    countryNameEn: 'Mexico',
    countryCallingCode: '52',
    center: [23, -102],
  },
  {
    countryCode: 'MY',
    countryNameEn: 'Malaysia',
    countryCallingCode: '60',
    center: [2.5, 112.5],
  },
  {
    countryCode: 'MZ',
    countryNameEn: 'Mozambique',
    countryCallingCode: '258',
    center: [-18.25, 35],
  },
  {
    countryCode: 'NA',
    countryNameEn: 'Namibia',
    countryCallingCode: '264',
    center: [-22, 17],
  },
  {
    countryCode: 'NC',
    countryNameEn: 'New Caledonia',
    countryCallingCode: '687',
    center: [-21.5, 165.5],
  },
  {
    countryCode: 'NF',
    countryNameEn: 'Norfolk Island',
    countryCallingCode: '672',
    center: [-29.0333, 167.95],
  },
  {
    countryCode: 'NG',
    countryNameEn: 'Nigeria',
    countryCallingCode: '234',
    center: [10, 8],
  },
  {
    countryCode: 'NI',
    countryNameEn: 'Nicaragua',
    countryCallingCode: '505',
    center: [13, -85],
  },
  {
    countryCode: 'NO',
    countryNameEn: 'Norway',
    countryCallingCode: '47',
    center: [62, 10],
  },
  {
    countryCode: 'NP',
    countryNameEn: 'Nepal',
    countryCallingCode: '977',
    center: [28, 84],
  },
  {
    countryCode: 'NR',
    countryNameEn: 'Nauru',
    countryCallingCode: '674',
    center: [-0.5333, 166.9167],
  },
  {
    countryCode: 'NU',
    countryNameEn: 'Niue',
    countryCallingCode: '683',
    center: [-19.0333, -169.8667],
  },
  {
    countryCode: 'NZ',
    countryNameEn: 'New Zealand',
    countryCallingCode: '64',
    center: [-41, 174],
  },
  {
    countryCode: 'OM',
    countryNameEn: 'Oman',
    countryCallingCode: '968',
    center: [21, 57],
  },
  {
    countryCode: 'PA',
    countryNameEn: 'Panama',
    countryCallingCode: '507',
    center: [9, -80],
  },
  {
    countryCode: 'PE',
    countryNameEn: 'Peru',
    countryCallingCode: '51',
    center: [-10, -76],
  },
  {
    countryCode: 'PF',
    countryNameEn: 'French Polynesia',
    countryCallingCode: '689',
    center: [-15, -140],
  },
  {
    countryCode: 'PG',
    countryNameEn: 'Papua New Guinea',
    countryCallingCode: '675',
    center: [-6, 147],
  },
  {
    countryCode: 'PK',
    countryNameEn: 'Pakistan',
    countryCallingCode: '92',
    center: [30, 70],
  },
  {
    countryCode: 'PL',
    countryNameEn: 'Poland',
    countryCallingCode: '48',
    center: [52, 20],
  },
  {
    countryCode: 'PM',
    countryNameEn: 'Saint Pierre and Miquelon',
    countryCallingCode: '508',
    center: [46.8333, -56.3333],
  },
  {
    countryCode: 'PN',
    countryNameEn: 'Pitcairn',
    countryCallingCode: '64',
    center: [-24.7, -127.4],
  },
  {
    countryCode: 'PR',
    countryNameEn: 'Puerto Rico',
    countryCallingCode: '1',
    center: [18.25, -66.5],
  },
  {
    countryCode: 'PS',
    countryNameEn: 'State of Palestine',
    countryCallingCode: '970',
    center: [32, 35.25],
  },
  {
    countryCode: 'PT',
    countryNameEn: 'Portugal',
    countryCallingCode: '351',
    center: [39.5, -8],
  },
  {
    countryCode: 'PW',
    countryNameEn: 'Palau',
    countryCallingCode: '680',
    center: [7.5, 134.5],
  },
  {
    countryCode: 'PY',
    countryNameEn: 'Paraguay',
    countryCallingCode: '595',
    center: [-23, -58],
  },
  {
    countryCode: 'QA',
    countryNameEn: 'Qatar',
    countryCallingCode: '974',
    center: [25.5, 51.25],
  },
  {
    countryCode: 'RE',
    countryNameEn: 'Réunion',
    countryCallingCode: '262',
    center: [-21.1, 55.6],
  },
  {
    countryCode: 'RO',
    countryNameEn: 'Romania',
    countryCallingCode: '40',
    center: [46, 25],
  },
  {
    countryCode: 'RS',
    countryNameEn: 'Serbia',
    countryCallingCode: '381',
    center: [44, 21],
  },
  {
    countryCode: 'RU',
    countryNameEn: 'Russia',
    countryCallingCode: '7',
    center: [60, 100],
  },
  {
    countryCode: 'RW',
    countryNameEn: 'Rwanda',
    countryCallingCode: '250',
    center: [-2, 30],
  },
  {
    countryCode: 'SA',
    countryNameEn: 'Saudi Arabia',
    countryCallingCode: '966',
    center: [25, 45],
  },
  {
    countryCode: 'SB',
    countryNameEn: 'Solomon Islands',
    countryCallingCode: '677',
    center: [-8, 159],
  },
  {
    countryCode: 'SC',
    countryNameEn: 'Seychelles',
    countryCallingCode: '248',
    center: [-4.5833, 55.6667],
  },
  {
    countryCode: 'SE',
    countryNameEn: 'Sweden',
    countryCallingCode: '46',
    center: [62, 15],
  },
  {
    countryCode: 'SG',
    countryNameEn: 'Singapore',
    countryCallingCode: '65',
    center: [1.3667, 103.8],
  },
  {
    countryCode: 'SH',
    countryNameEn: 'Saint Helena, Ascension and Tristan da Cunha',
    countryCallingCode: '290',
    center: [-15.9333, -5.7],
  },
  {
    countryCode: 'SI',
    countryNameEn: 'Slovenia',
    countryCallingCode: '386',
    center: [46, 15],
  },
  {
    countryCode: 'SJ',
    countryNameEn: 'Svalbard and Jan Mayen',
    countryCallingCode: '4779',
    center: [78, 20],
  },
  {
    countryCode: 'SK',
    countryNameEn: 'Slovakia',
    countryCallingCode: '421',
    center: [48.6667, 19.5],
  },
  {
    countryCode: 'SL',
    countryNameEn: 'Sierra Leone',
    countryCallingCode: '232',
    center: [8.5, -11.5],
  },
  {
    countryCode: 'SM',
    countryNameEn: 'San Marino',
    countryCallingCode: '378',
    center: [43.7667, 12.4167],
  },
  {
    countryCode: 'SN',
    countryNameEn: 'Senegal',
    countryCallingCode: '221',
    center: [14, -14],
  },
  {
    countryCode: 'SO',
    countryNameEn: 'Somalia',
    countryCallingCode: '252',
    center: [10, 49],
  },
  {
    countryCode: 'SR',
    countryNameEn: 'Suriname',
    countryCallingCode: '597',
    center: [4, -56],
  },
  {
    countryCode: 'SS',
    countryNameEn: 'South Sudan',
    countryCallingCode: '211',
    center: undefined,
  },
  {
    countryCode: 'ST',
    countryNameEn: 'Sao Tome and Principe',
    countryCallingCode: '239',
    center: [1, 7],
  },
  {
    countryCode: 'SV',
    countryNameEn: 'El Salvador',
    countryCallingCode: '503',
    center: [13.8333, -88.9167],
  },
  {
    countryCode: 'SX',
    countryNameEn: 'Sint Maarten (Dutch part)',
    countryCallingCode: '1721',
    center: [18.06, -63.06],
  },
  {
    countryCode: 'SY',
    countryNameEn: 'Syrian Arab Republic',
    countryCallingCode: '',
    center: [35, 38],
  },
  {
    countryCode: 'TD',
    countryNameEn: 'Chad',
    countryCallingCode: '235',
    center: [15, 19],
  },
  {
    countryCode: 'TG',
    countryNameEn: 'Togo',
    countryCallingCode: '228',
    center: [8, 1.1667],
  },
  {
    countryCode: 'TH',
    countryNameEn: 'Thailand',
    countryCallingCode: '66',
    center: [15, 100],
  },
  {
    countryCode: 'TJ',
    countryNameEn: 'Tajikistan',
    countryCallingCode: '992',
    center: [39, 71],
  },
  {
    countryCode: 'TK',
    countryNameEn: 'Tokelau',
    countryCallingCode: '690',
    center: [-9, -172],
  },
  {
    countryCode: 'TL',
    countryNameEn: 'Timor-Leste',
    countryCallingCode: '',
    center: [-8.55, 125.5167],
  },
  {
    countryCode: 'TM',
    countryNameEn: 'Turkmenistan',
    countryCallingCode: '993',
    center: [40, 60],
  },
  {
    countryCode: 'TN',
    countryNameEn: 'Tunisia',
    countryCallingCode: '216',
    center: [34, 9],
  },
  {
    countryCode: 'TO',
    countryNameEn: 'Tonga',
    countryCallingCode: '676',
    center: [-20, -175],
  },
  {
    countryCode: 'TR',
    countryNameEn: 'Turkey',
    countryCallingCode: '90',
    center: [39, 35],
  },
  {
    countryCode: 'TT',
    countryNameEn: 'Trinidad and Tobago',
    countryCallingCode: '868',
    center: [11, -61],
  },
  {
    countryCode: 'TV',
    countryNameEn: 'Tuvalu',
    countryCallingCode: '688',
    center: [-8, 178],
  },
  {
    countryCode: 'TZ',
    countryNameEn: 'United Republic of Tanzania',
    countryCallingCode: '255',
    center: [-6, 35],
  },
  {
    countryCode: 'UA',
    countryNameEn: 'Ukraine',
    countryCallingCode: '380',
    center: [49, 32],
  },
  {
    countryCode: 'UG',
    countryNameEn: 'Uganda',
    countryCallingCode: '256',
    center: [1, 32],
  },
  {
    countryCode: 'US',
    countryNameEn: 'United States of America',
    countryCallingCode: '1',
    center: [38, -97],
  },
  {
    countryCode: 'UY',
    countryNameEn: 'Uruguay',
    countryCallingCode: '598',
    center: [-33, -56],
  },
  {
    countryCode: 'UZ',
    countryNameEn: 'Uzbekistan',
    countryCallingCode: '998',
    center: [41, 64],
  },
  {
    countryCode: 'VC',
    countryNameEn: 'Saint Vincent and the Grenadines',
    countryCallingCode: '1784',
    center: [13.25, -61.2],
  },
  {
    countryCode: 'VE',
    countryNameEn: 'Venezuela (Bolivarian Republic of)',
    countryCallingCode: '58',
    center: [8, -66],
  },
  {
    countryCode: 'VG',
    countryNameEn: 'Virgin Islands (British)',
    countryCallingCode: '1284',
    center: [18.5, -64.5],
  },
  {
    countryCode: 'VI',
    countryNameEn: 'Virgin Islands (U.S.)',
    countryCallingCode: '1340',
    center: [18.3333, -64.8333],
  },
  {
    countryCode: 'VN',
    countryNameEn: 'Vietnam',
    countryCallingCode: '84',
    center: [16, 106],
  },
  {
    countryCode: 'VU',
    countryNameEn: 'Vanuatu',
    countryCallingCode: '678',
    center: [-16, 167],
  },
  {
    countryCode: 'WF',
    countryNameEn: 'Wallis and Futuna',
    countryCallingCode: '681',
    center: [-13.3, -176.2],
  },
  {
    countryCode: 'WS',
    countryNameEn: 'Samoa',
    countryCallingCode: '685',
    center: [-13.5833, -172.3333],
  },
  {
    countryCode: 'YE',
    countryNameEn: 'Yemen',
    countryCallingCode: '967',
    center: [15, 48],
  },
  {
    countryCode: 'YT',
    countryNameEn: 'Mayotte',
    countryCallingCode: '262',
    center: [-12.8333, 45.1667],
  },
  {
    countryCode: 'ZA',
    countryNameEn: 'South Africa',
    countryCallingCode: '27',
    center: [-29, 24],
  },
  {
    countryCode: 'ZM',
    countryNameEn: 'Zambia',
    countryCallingCode: '260',
    center: [-15, 30],
  },
  {
    countryCode: 'ZW',
    countryNameEn: 'Zimbabwe',
    countryCallingCode: '263',
    center: [-20, 30],
  },
  {
    countryCode: 'SZ',
    countryNameEn: 'Eswatini',
    countryCallingCode: '268',
    center: [-26.5, 31.5],
  },
  {
    countryCode: 'MK',
    countryNameEn: 'North Macedonia',
    countryCallingCode: '389',
    center: [41.8333, 22],
  },
  {
    countryCode: 'PH',
    countryNameEn: 'Philippines',
    countryCallingCode: '63',
    center: [13, 122],
  },
  {
    countryCode: 'NL',
    countryNameEn: 'Netherlands',
    countryCallingCode: '31',
    center: [52.5, 5.75],
  },
  {
    countryCode: 'AE',
    countryNameEn: 'United Arab Emirates',
    countryCallingCode: '971',
    center: [24, 54],
  },
  {
    countryCode: 'MD',
    countryNameEn: 'Republic of Moldova',
    countryCallingCode: '373',
    center: [47, 29],
  },
  {
    countryCode: 'GM',
    countryNameEn: 'Gambia',
    countryCallingCode: '220',
    center: [13.4667, -16.5667],
  },
  {
    countryCode: 'DO',
    countryNameEn: 'Dominican Republic',
    countryCallingCode: '1',
    center: [19, -70.6667],
  },
  {
    countryCode: 'SD',
    countryNameEn: 'Sudan',
    countryCallingCode: '249',
    center: [15, 30],
  },
  {
    countryCode: 'LA',
    countryNameEn: "Lao People's Democratic Republic",
    countryCallingCode: '',
    center: [18, 105],
  },
  {
    countryCode: 'TW',
    countryNameEn: 'Taiwan (Province of China)',
    countryCallingCode: '886',
    center: [23.5, 121],
  },
  {
    countryCode: 'CG',
    countryNameEn: 'Republic of the Congo',
    countryCallingCode: '242',
    center: [-1, 15],
  },
  {
    countryCode: 'CZ',
    countryNameEn: 'Czechia',
    countryCallingCode: '420',
    center: [49.75, 15.5],
  },
  {
    countryCode: 'GB',
    countryNameEn: 'United Kingdom',
    countryCallingCode: '44',
    center: [54, -2],
  },
  {
    countryCode: 'NE',
    countryNameEn: 'Niger',
    countryCallingCode: '227',
    center: [16, 8],
  },
  {
    countryCode: 'CD',
    countryNameEn: 'Democratic Republic of the Congo',
    countryCallingCode: '243',
    center: [0, 25],
  },
  {
    countryCode: 'BS',
    countryNameEn: 'Commonwealth of The Bahamas',
    countryCallingCode: '1 242',
    center: [24.25, -76],
  },
  {
    countryCode: 'CC',
    countryNameEn: 'Cocos (Keeling) Islands',
    countryCallingCode: '61 891',
    center: [-12.5, 96.8333],
  },
  {
    countryCode: 'CF',
    countryNameEn: 'Central African Republic',
    countryCallingCode: '236',
    center: [7, 21],
  },
  {
    countryCode: 'CK',
    countryNameEn: 'Cook Islands',
    countryCallingCode: '682',
    center: [-21.2333, -159.7667],
  },
  {
    countryCode: 'FK',
    countryNameEn: 'Falkland Islands',
    countryCallingCode: '500',
    center: [-51.75, -59],
  },
  {
    countryCode: 'FO',
    countryNameEn: 'Faroe Islands',
    countryCallingCode: '298',
    center: [62, -7],
  },
  {
    countryCode: 'HM',
    countryNameEn: 'Territory of Heard Island and McDonald Islands',
    countryCallingCode: '672',
    center: [-53.1, 72.5167],
  },
  {
    countryCode: 'IO',
    countryNameEn: 'British Indian Ocean Territory',
    countryCallingCode: '246',
    center: [-6, 71.5],
  },
  {
    countryCode: 'KM',
    countryNameEn: 'Comoros',
    countryCallingCode: '269',
    center: [-12.1667, 44.25],
  },
  {
    countryCode: 'KY',
    countryNameEn: 'Cayman Islands',
    countryCallingCode: '1 345',
    center: [19.5, -80.5],
  },
  {
    countryCode: 'MH',
    countryNameEn: 'Republic of the Marshall Islands',
    countryCallingCode: '692',
    center: [9, 168],
  },
  {
    countryCode: 'MP',
    countryNameEn: 'Commonwealth of the Northern Mariana Islands',
    countryCallingCode: '1 670',
    center: [15.2, 145.75],
  },
  {
    countryCode: 'TC',
    countryNameEn: 'Turks and Caicos Islands',
    countryCallingCode: '1 649',
    center: [21.75, -71.5833],
  },
  {
    countryCode: 'TF',
    countryNameEn: 'French Southern and Antarctic Lands',
    countryCallingCode: '672',
    center: [-43, 67],
  },
  {
    countryCode: 'UM',
    countryNameEn: 'United States Minor Outlying Islands',
    countryCallingCode: '246',
    center: [19.2833, 166.6],
  },
  {
    countryCode: 'VA',
    countryNameEn: 'Holy See',
    countryCallingCode: '39',
    center: [41.9, 12.45],
  },
  {
    countryCode: 'XK',
    countryNameEn: 'Republic of Kosovo',
    countryCallingCode: '383',
    center: [42.56, 20.34],
  },
  {
    countryCode: 'AN',
    countryNameEn: 'Netherlands Antilles',
    countryCallingCode: '599',
    center: [12.25, -68.75],
  },
];
